var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 10,
    viewBox: "0 0 48 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#01AE8F",
    d: "M48 5.508c-.419 0-47.56-.006-48-.016",
    transform: "translate(-722 -1423) translate(461.5 10) translate(.5 95) translate(0 463) translate(0 736) translate(32 68) translate(228 51)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01AE8F",
    d: "M45.012 1.222l3.426 8.4c.209.512-.037 1.095-.548 1.304-.12.049-.248.074-.378.074h-7c-.552 0-1-.448-1-1 0-.135.027-.268.08-.392l3.574-8.4C43.382.7 43.97.465 44.478.68c.243.103.435.298.534.542z",
    transform: "translate(-722 -1423) translate(461.5 10) translate(.5 95) translate(0 463) translate(0 736) translate(32 68) translate(228 51) rotate(90 44 5)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3e217a35db6c064bb0d4eb7e9b4a17d0.svg";
export { ForwardRef as ReactComponent };